import { createContext } from 'react';
import type { EmailVerificationContextType } from './EmailVerificationTypes';

const EmailVerificationContext = createContext<EmailVerificationContextType | null>(null);

export default EmailVerificationContext;

